<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div
    class="content-toolbar"
    :class="{ 'has-selection': effectiveHasSelection }"
  >
    <div class="content-toolbar-left">
      <slot
        v-if="effectiveHasSelection"
        name="selection"
        :has-selection="effectiveHasSelection"
        :selected-count="selectedCount"
      />
      <slot v-else :has-selection="effectiveHasSelection" />
    </div>
    <div class="content-toolbar-right">
      <slot name="right" :has-selection="effectiveHasSelection" />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useSelectionStore } from "@/stores/selection";

export default {
  name: "ContentToolbar",
  props: {
    hasSelection: {
      type: Boolean,
      default: undefined,
    },
  },
  setup(props) {
    const selectionStore = useSelectionStore();

    const selectedCount = computed(() => selectionStore.nodes.length);

    const effectiveHasSelection = computed(() => {
      if (props.hasSelection !== undefined) {
        return props.hasSelection;
      }
      return selectionStore.nodes.length > 0;
    });

    return {
      effectiveHasSelection,
      selectedCount,
    };
  },
};
</script>

<style lang="scss" scoped>
.content-toolbar {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  background: var(--p-content-background);
  border: 1px solid var(--p-content-border-color);
  border-radius: 0.5rem;

  &.has-selection {
    background: color-mix(
      in srgb,
      var(--p-primary-color) 12%,
      var(--p-content-background)
    );
    border-color: color-mix(
      in srgb,
      var(--p-primary-color) 30%,
      var(--p-content-border-color)
    );
  }
}

.content-toolbar-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.content-toolbar-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
